import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VListItem,{staticClass:"mb-2 mx-4 rounded-lg white",attrs:{"ripple":false}},[_c(VListItemAvatar,[_c(VIcon,[_vm._v("mdi-comment-text-outline")])],1),_vm._v(" "+_vm._s(_vm.customerComment)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }